<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <!-- Logo et nom -->
        <div class="logo-container">
          <router-link to="/" class="logo-link">
            <img src="@/assets/logo.png" alt="Kissmywheels" class="logo" />
            <span class="brand-name">
              LifeRacer / KissMyWheels
            </span>
          </router-link>
        </div>

        <!-- Navigation et sélecteur de langue -->
        <div class="nav-container">
          <!-- Navigation principale -->
          <nav class="main-nav">
            <router-link
              to="/"
              class="nav-link"
              :class="{ 'active': $route.path === '/' }"
            >
              {{ $t('common.home') }}
            </router-link>
            <router-link
              to="/booking"
              class="nav-link"
              :class="{ 'active': $route.path.startsWith('/booking') }"
            >
              {{ $t('common.booking') }}
            </router-link>
          </nav>

          <!-- Sélecteur de langue -->
          <div class="lang-selector">
            <span class="globe-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clip-rule="evenodd" />
              </svg>
            </span>
            <LanguageSelector />
          </div>

          <!-- Menu mobile -->
          <button
            @click="toggleMobileMenu"
            class="mobile-menu-button"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" fill="none">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Menu mobile -->
      <div
        v-if="isMobileMenuOpen"
        class="mobile-menu"
      >
        <div class="mobile-menu-links">
          <router-link
            to="/"
            class="mobile-nav-link"
            :class="{ 'active': $route.path === '/' }"
            @click="isMobileMenuOpen = false"
          >
            {{ $t('common.home') }}
          </router-link>
          <router-link
            to="/booking"
            class="mobile-nav-link"
            :class="{ 'active': $route.path.startsWith('/booking') }"
            @click="isMobileMenuOpen = false"
          >
            {{ $t('common.booking') }}
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import LanguageSelector from './LanguageSelector.vue'

const isMobileMenuOpen = ref(false)

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}
</script>

<style scoped>
.header {
  background-color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem 1rem;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo {
  height: 32px;
  width: auto;
}

.brand-name {
  margin-left: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  color: var(--primary-color);
}

.nav-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.main-nav {
  display: none;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .main-nav {
    display: flex;
  }
}

.nav-link {
  color: #4b5563;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.nav-link:hover,
.nav-link.active {
  color: var(--primary-color);
}

.lang-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.globe-icon {
  color: #9ca3af;
}

.mobile-menu-button {
  display: flex;
  padding: 0.25rem;
  color: #4b5563;
  cursor: pointer;
  border: none;
  background: none;
}

@media (min-width: 768px) {
  .mobile-menu-button {
    display: none;
  }
}

.mobile-menu {
  display: block;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e5e7eb;
}

.mobile-menu-links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.mobile-nav-link {
  color: #4b5563;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.mobile-nav-link:hover,
.mobile-nav-link.active {
  color: var(--primary-color);
}

@media (min-width: 768px) {
  .mobile-menu {
    display: none;
  }
}
</style> 